var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-center-new-details"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.details.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }